<template>
    <div class="bg-White">
        <Mainlayout></Mainlayout>
        <CCol sm="12" style="background-size: cover; color: #fff;background: #007cef;">
    
            <CCol sm="12" lg="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
                <CRow>
                    <CCol sm="12" lg="12">
                        <div style="margin-top:15%">
                            <h3 class="mt-2 custom-header-title text-center text-white">Empower Your E-Learning Journey</h3>
                            <br />
                            <p class="custom-18px-500 text-center">
                                Embark on a dynamic learning journey with our E-Learning & Training platform, meticulously crafted for learners of all ages. With a diverse <br /> array of courses, interactive content, and adaptable learning options, our programs
                                are meticulously tailored to elevate both your academic <br /> and professional growth.
                            </p>
                            <CCol sm="12" lg="12" style="width: 60%;background-size: cover; margin: auto;color: #fff">
                                <CRow>
                                    <CCol sm="4">
                                        <h3 class="custom-28px-700">125+</h3>
                                        <p class="text-center">Course</p>
                                    </CCol>
                                    <CCol sm="4">
                                        <h3 class="custom-28px-700">125+</h3>
                                        <p class="text-center">Verified Tutor</p>
                                    </CCol>
                                    <CCol sm="4">
                                        <h3 class="custom-28px-700">125+</h3>
                                        <p class="text-center">Good Reviews</p>
                                    </CCol>
                                </CRow>
                            </CCol>
                            <CCol sm="12">
                                <div class="text-center mb-5 mt-3">
                                    <CButton type="button" class="btn custom-button-white-bg color-blue-new"><span class="ml-4 mr-4">Contact Us</span></CButton>
                                </div>
                            </CCol>
                        </div>
                    </CCol>
    
    
    
                </CRow>
            </CCol>
        </CCol>
    
        <CCol sm="12" class="bg-white">
    
            <CCol sm="12" style="width: 80%;background-size: cover; margin: auto;color: #fff">
                <CRow class="">
                    <CCol sm="12">
                        <br /><br />
                        <h3 class="custom-32px text-center mt-5">Top-notch Video and Audio of Quality</h3>
                        <CCol sm="12" style="margin:auto">
                            <div class="text-center">
                                <img style="max-width:80%" src="../assets/img/videouser.png" class="text-center" />
                                <p class="custom-sub-text text-center">
                                    Dive into video lessons, and at each checkpoint, face engaging quizzes.<br /> Answering right propels you seamlessly forward. Embrace the challenge—let <br /> curiosity guide your educational adventure! </p>
                            </div>
                        </CCol>
    
                        <br /><br />
    
    
                    </CCol>
                </CRow>
    
            </CCol>
    
        </CCol>
    
        <CCol sm="12" class="bg-white">
            <CCol sm="12" lg="12" style="width: 80%;background-size: cover; margin: auto;color: #fff">
                <CRow>
                    <CCol sm="3"><img style="max-width:100%" src="../assets/img/it1.png" />
                        <h3 class="custom-20px-600">Programming</h3>
                        <p class="custom-12px-500 text-center">
                            1103 classes
                        </p>
                    </CCol>
                    <CCol sm="3"><img style="max-width:100%" src="../assets/img/it1.png" />
                        <h3 class="custom-20px-600">AI</h3>
                        <p class="custom-12px-500 text-center">
                            1103 classes
                        </p>
                    </CCol>
                    <CCol sm="3"><img style="max-width:100%" src="../assets/img/it2.png" />
                        <h3 class="custom-20px-600">Public Speaking</h3>
                        <p class="custom-12px-500 text-center">
                            1103 classes
                        </p>
                    </CCol>
                    <CCol sm="3"><img style="max-width:100%" src="../assets/img/it1.png" />
                        <h3 class="custom-20px-600">IT Tech</h3>
                        <p class="custom-12px-500 text-center">
                            1103 classes
                        </p>
                    </CCol>
                </CRow>
            </CCol>
        </CCol>
    
        <CCol sm="12" class="bg-grey">
            <CCol sm="12" lg="12">
                <div class="text-center">
                    <br /><br />
                    <CCol sm="12" style="width: 90%;background-size: cover; margin: auto;">
                        <br />
                        <CRow class="mt-5">
                            <CCol sm="12">
                                <h1 class="custom-header-title-choose text-black mt-3 p-40 text-center poppin-font text-60px"> Training Courses</h1>
                                <h3 class="mt-4 mb-4 text-black text-24px text-center p-40">Highlighting dedicated training courses, our platform aims to steer users towards exploring premium content, emphasizing pivotal learning opportunities.</h3>
                                <br />
                                <CInput type="text" />
    
                                <div class="border-white-radius text-black mb-4">
                                    <span class="m-2">ALL</span>
                                    <span class="m-2"><img style="max-width:100px" src="../assets/img/copywriting.png" /></span>
                                    <span class="m-2">Photo Generator</span>
                                    <span class="m-2">Coding (Beginner)</span>
                                    <span class="m-2">Coding (Intermediate)</span>
                                    <span class="m-2">Coding (Advance)</span>
                                    <span class="m-2">Programming</span>
                                </div>
    
                            </CCol>
    
                        </CRow>
                        <CRow>
                            <CCol sm="3"><img style="max-width:100%" src="../assets/img/t1.png" /></CCol>
                            <CCol sm="3"><img style="max-width:100%" src="../assets/img/t2.png" /></CCol>
                            <CCol sm="3"><img style="max-width:100%" src="../assets/img/t3.png" /></CCol>
                            <CCol sm="3"><img style="max-width:100%" src="../assets/img/t4.png" /></CCol>
    
    
                        </CRow>
                        <CRow class="mt-2 mb-2">
                            <CCol sm="3"><img style="max-width:100%" src="../assets/img/t5.png" /></CCol>
                            <CCol sm="3"><img style="max-width:100%" src="../assets/img/t6.png" /></CCol>
                            <CCol sm="3"><img style="max-width:100%" src="../assets/img/t7.png" /></CCol>
                            <CCol sm="3"><img style="max-width:100%" src="../assets/img/t8.png" /></CCol>
                        </CRow>
                        <CRow>
    
                        </CRow>
    
                    </CCol>
                </div>
            </CCol>
    
        </CCol>
    
    
        <CCol sm="12" class="bg-white">
            <br /> <br /> <br />
            <CCol sm="12" lg="12">
                <div class="text-center p-2">
                    <CCol sm="12" style="width: 80%;margin: auto;">
                        <div class="text-center">
                            <br />
                            <h1 class="custom-text-aladdin text-black poppin-font text-48px mb-5">
                                Our Tutor
                            </h1>
                        </div>
                        <CRow>
                            <CCol sm="3">
                                <img src="../assets/img/m1.png" style="max-width:100%" />
                                <h3 class="poppin-font text-black text-24px text-bold mt-5 custom-text-aladdin-sub text-center">Rasid</h3>
                                <label class="text-left text-grey custom-result-grey">Proffesional Entrepreneur</label>
                                <CButton class="custom-button-profile color-blue mb-5">Detail</CButton>
    
                            </CCol>
                            <CCol sm="3"> <img src="../assets/img/m2.png" style="max-width:100%" />
                                <h3 class="poppin-font text-black text-24px text-bold mt-5 custom-text-aladdin-sub text-center">Ridhwan Salimi</h3>
                                <label class="text-center text-grey custom-result-grey">Proffesional Public Speaker</label>
                                <CButton class="custom-button-profile color-blue mb-5">Detail</CButton>
                            </CCol>
                            <CCol sm="3"> <img src="../assets/img/m3.png" style="max-width:100%" />
                                <h3 class="poppin-font text-black text-24px text-bold mt-5 custom-text-aladdin-sub text-center">Cikgu Ilmi</h3>
                                <label class="text-center text-grey custom-result-grey">Proffesional Math Teacher</label>
                                <CButton class="custom-button-profile color-blue mb-5">Detail</CButton>
                            </CCol>
                            <CCol sm="3"> <img src="../assets/img/m4.png" style="max-width:100%" />
                                <h3 class="poppin-font text-black text-24px text-bold mt-5 custom-text-aladdin-sub text-center">Dr. Irfan</h3>
                                <label class="text-center text-grey custom-result-grey">Lecture at Singapore Uni.</label>
                                <CButton class="custom-button-profile color-blue mb-5">Detail</CButton>
                            </CCol>
                        </CRow>
                    </CCol>
                </div>
            </CCol>
        </CCol>
    
    
        <CCol sm="12" class="bg-grey">
            <br /> <br /> <br />
            <CCol sm="12" lg="12">
                <div class="text-center p-2">
                    <CCol sm="12" style="width: 90%;margin: auto;">
                        <div class="text-center">
                            <br /><br /><br />
                            <h1 class="custom-text-aladdin text-black poppin-font text-48px">
                                What our students say about us.
                            </h1>
                            <br /><br /><br />
                            <CRow class="mt-4">
                                <CCol sm="4">
                                    <CCard class="bg-white b-20 p-40" style="min-height:400px;border:none">
                                        <div class="text-left">
                                            <img style="max-width:30px" src="../assets/img/quote1.png" class="mt-5" />
    
                                            <h3 class="poppin-font text-black text-24px text-bold mt-5 custom-text-aladdin-sub text-left">Interactive Elements</h3>
                                            <label class="text-left text-grey custom-result-grey">“I appreciated the interactive elements, such as quizzes and reflection exercises. These not only kept me 
                                                                engaged but also allowed for self-assessment, reinforcing the key concepts discussed in the video.”</label>
    
                                            <br />
                                            <span class="border-grey">
                                                            <img style="max-width:40px" src="../assets/img/star1.png" /> 5.0
                                                          </span>
                                            <CRow class="mt-2 mb-5">
                                                <CCol sm="3"> <img style="max-width:50px" src="../assets/img/user2.png" /></CCol>
                                                <CCol sm="9">
                                                    <CCol sm="10"><label class="text-black text-left mt-2">Skylar Siphron <br />Professional
                                                                                                        </label></CCol>
    
                                                </CCol>
                                            </CRow>
                                        </div>
    
                                    </CCard>
                                </CCol>
                                <CCol sm="4">
                                    <CCard class="bg-white b-20 p-40" style="min-height:500px;border:none">
                                        <div class="text-left">
                                            <img style="max-width:30px" src="../assets/img/quote1.png" class="mt-5" />
    
                                            <h3 class="poppin-font text-black text-24px text-bold mt-5 custom-text-aladdin-sub text-left">Family Gatherings Made Easy</h3>
                                            <label class="text-left text-grey custom-result-grey">“The inclusion of practical tips and best practices for handling challenging customer interactions was valuable. It's evident that the content is rooted in real-world scenarios, which adds a practical dimension to the training”</label>
                                            <span class="border-grey">
                                                            <img style="max-width:40px" src="../assets/img/star1.png" /> 5.0
                                                          </span>
                                            <CRow class="mt-2 mb-5">
                                                <CCol sm="3"> <img style="max-width:50px" src="../assets/img/user4.png" /></CCol>
                                                <CCol sm="9">
                                                    <CCol sm="10"><label class="text-black text-left mt-2">Skylar Siphron <br />Professional
                                                                                                        </label></CCol>
    
                                                </CCol>
                                            </CRow>
    
                                        </div>
    
                                    </CCard>
                                </CCol>
    
                                <CCol sm="4">
                                    <CCard class="bg-white b-20 p-40" style="min-height:500px;border:none">
                                        <div class="text-left">
                                            <img style="max-width:30px" src="../assets/img/quote1.png" class="mt-5" />
    
                                            <h3 class="poppin-font text-black text-24px text-bold mt-5 custom-text-aladdin-sub text-left">Foodie Express never disappoints</h3>
                                            <label class="text-left text-grey custom-result-grey">“The content was presented in a clear and concise manner, making it easy to follow. The breakdown of different customer service strategies and the emphasis on empathy were particularly helpful.”</label>
                                            <span class="border-grey">
                                                            <img style="max-width:40px" src="../assets/img/star1.png" /> 5.0
                                                          </span>
                                            <CRow class="mt-2 mb-5">
                                                <CCol sm="3"> <img style="max-width:50px" src="../assets/img/user5.png" /></CCol>
                                                <CCol sm="9">
                                                    <CCol sm="10"><label class="text-black text-left mt-2">Skylar Siphron <br />Professional
                                                                                                        </label></CCol>
    
                                                </CCol>
                                            </CRow>
    
                                        </div>
    
                                    </CCard>
                                </CCol>
    
                            </CRow>
                        </div>
    
                    </CCol>
                </div>
            </CCol>
        </CCol>
        <CCol sm="12" style="background-size: cover; color: #fff;background: #007cef;">
    
            <CCol sm="12" lg="12">
                <CRow>
                    <CCol sm="12" lg="12">
                        <div>
    
                            <CCol sm="12" lg="12" style="width: 80%;background-size: cover; margin: auto;color: #fff">
                                <CRow>
                                    <CCol sm="6">
                                        <img src="../assets/img/phonetab.png" style="max-width:100%" />
                                    </CCol>
                                    <CCol sm="6">
                                        <br /><br />
                                        <h1 class="custom-48px-white mt-5">
                                            Download Our <br /> Mobile App
                                        </h1>
                <br />
                <p class="custom-16px-500 text-white">Our application can be found in the store below</p>
                
                                        <CRow class="mt-3 ml-2">
                                            <img style="max-width:100%" src="../assets/img/googleplay.png" class="mr-2" />
                                            <img style="max-width:100%" src="../assets/img/appstore.png" />
                                        </CRow>
                                    </CCol>
    
                                </CRow>
                            </CCol>
                        </div>
                    </CCol>
    
    
    
                </CRow>
            </CCol>
        </CCol>
    
        <Footerlayout></Footerlayout>
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bg.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap

        };
    },
    created() {
        AOS.init();
    },

};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat');
body {
    top: 0 !important;
    font-family: 'Montserrat', sans-serif;
}

.custom-tab .nav-link.active {
    border-bottom: 2px solid #000;
    /* Replace with your desired border color */
}
</style>